<template>
	<div>
		<ul class="integration-list">
			<li
				:id="`${uid}_${item.id}`"
				class="integration-list__item"
				v-for="item in items"
				:key="item.id"
			>
				<IntegrationCard
					:id="`${uid}_${item.id}_card`"
					:source="item"
					:thirdPartyId="thirdPartyId"
				/>
			</li>
		</ul>
	</div>
</template>

<script>
import IntegrationCard from './integration-card.vue';

export default {
	name: 'IntegrationList',
	components: {
		IntegrationCard
	},
	props: {
		thirdPartyId: {
			type: Number,
			required: true
		},
		items: Array
	}
};
</script>

<style lang="scss" scoped>
/**
    * Results List
    * Can use SCSS variables = TRUE
	* [Table of Contents]
    *
    * BASE
    * BASE DESKTOP-UP
*/

/*------------------------------------*\
  #BASE
\*------------------------------------*/

.integration-list {
	list-style: none;
	padding: 0;
	overflow-y: auto;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
	grid-template-rows: auto;
	gap: 12px;
	align-content: start;
}

/*------------------------------------*\
  #BASE DESKTOP-UP
\*------------------------------------*/
@include mq($from: lg) {
	.integration-list {
		grid-template-columns: 1fr 1fr;
	}
}
</style>
